import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export type SearchConditionState = SearchConditionItem[];
export interface SearchConditionItem {
  searchConditionGroupId?: number;
  searchConditionName: string;
  specifiedCondition: (string | null)[];
  checked?: boolean;
  isUsedInFilter?: boolean;
}

export const initialState: SearchConditionState = [];

export const SearchConditionReducer = reducerWithInitialState(initialState).case(
  actions.updateSearchCondition,
  (state: SearchConditionState, payload: SearchConditionState) => {
    return payload;
  },
);
